import { instance } from "@/api/index";

function login(param) {
    return instance.post("/auth/login", param);
}

function refresh(param) {
    return instance.get("/auth/refresh", { params: param, skipLoading: true });
}


export { login, refresh, };